/**
 * 向本地浏览器的某个对象中存储json数据
 * @param localObject 本地对象  localStorage或者sessionStorage
 * @param key
 * @param value
 */
export function setJsonObjectToLocal(localObject,key,value){
  // 获得localStorage对象
  let jsonStr = JSON.stringify(value);
  localObject.setItem(key,jsonStr);
}
/**
 * 根据key获取本地浏览器某个对象的存储json数据
 * @param localObject  本地对象  localStorage或者sessionStorage
 * @param key
 * @returns {DOMPoint|SVGNumber|string|SVGTransform|SVGLength|SVGPathSeg|any}
 */
export function getJsonObjectFromLocal(localObject,key){
  // 获得localStorage对象
  let value = localObject.getItem(key)
  if(value){
    // 格式化成json对象
    let jsonObj = JSON.parse(value);
    // 赋值给当前显示列
    if(jsonObj){
      return jsonObj;
    }
  }
  return undefined;
}
/**
 * 清除本地key对应的数据
 * @param localObject
 * @param key
 */
export function clearDataFromLocal(localObject,key){
  localObject.removeItem(key)
}



// WEBPACK FOOTER //
// ./src/utils/localstorage.js